import {
    CREATE_COLLECTION_RECORD,
    CREATE_COLLECTION_RECORD_SUCCESS,
    CREATE_COLLECTION_RECORD_ERROR,
    UPDATE_COLLECTION_RECORD_STATE,
  } from "../actions";
  
  export const createCollectionRecord = (newRecord, history, id) => ({
    type: CREATE_COLLECTION_RECORD,
    payload: { newRecord, history, id }
  });
  
  export const createCollectionRecordSuccess = (collectionItemSaved) => ({
    type: CREATE_COLLECTION_RECORD_SUCCESS,
    payload: collectionItemSaved,
  });
  
  export const createCollectionRecordError = (message) => ({
    type: CREATE_COLLECTION_RECORD_ERROR,
    payload: { message },
  });
  
  export const updateCollectionRecordState = (updatedValues) => ({
    type: UPDATE_COLLECTION_RECORD_STATE,
    payload: { updatedValues }
  });